// extracted by mini-css-extract-plugin
export default {"colorPaletteWrapper":"TCeEEFjqDyjPZzyOpTbKgg=="};